var _classCallCheck = require("/codebuild/output/src1039780453/src/web/node_modules/@babel/runtime/helpers/classCallCheck.js");

var _createClass = require("/codebuild/output/src1039780453/src/web/node_modules/@babel/runtime/helpers/createClass.js");

var _inherits = require("/codebuild/output/src1039780453/src/web/node_modules/@babel/runtime/helpers/inherits.js");

var _possibleConstructorReturn = require("/codebuild/output/src1039780453/src/web/node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");

var _getPrototypeOf = require("/codebuild/output/src1039780453/src/web/node_modules/@babel/runtime/helpers/getPrototypeOf.js");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var Prefixer = require('./prefixer');

var OldValue = require('./old-value');

var vendor = require('./vendor');

var utils = require('./utils');

var Value = /*#__PURE__*/function (_Prefixer) {
  "use strict";

  _inherits(Value, _Prefixer);

  var _super = _createSuper(Value);

  function Value() {
    _classCallCheck(this, Value);

    return _super.apply(this, arguments);
  }

  _createClass(Value, [{
    key: "check",
    value:
    /**
     * Is declaration need to be prefixed
     */
    function check(decl) {
      var value = decl.value;

      if (!value.includes(this.name)) {
        return false;
      }

      return !!value.match(this.regexp());
    }
    /**
     * Lazy regexp loading
     */

  }, {
    key: "regexp",
    value: function regexp() {
      return this.regexpCache || (this.regexpCache = utils.regexp(this.name));
    }
    /**
     * Add prefix to values in string
     */

  }, {
    key: "replace",
    value: function replace(string, prefix) {
      return string.replace(this.regexp(), "$1".concat(prefix, "$2"));
    }
    /**
     * Get value with comments if it was not changed
     */

  }, {
    key: "value",
    value: function value(decl) {
      if (decl.raws.value && decl.raws.value.value === decl.value) {
        return decl.raws.value.raw;
      } else {
        return decl.value;
      }
    }
    /**
     * Save values with next prefixed token
     */

  }, {
    key: "add",
    value: function add(decl, prefix) {
      if (!decl._autoprefixerValues) {
        decl._autoprefixerValues = {};
      }

      var value = decl._autoprefixerValues[prefix] || this.value(decl);
      var before;

      do {
        before = value;
        value = this.replace(value, prefix);
        if (value === false) return;
      } while (value !== before);

      decl._autoprefixerValues[prefix] = value;
    }
    /**
     * Return function to fast find prefixed value
     */

  }, {
    key: "old",
    value: function old(prefix) {
      return new OldValue(this.name, prefix + this.name);
    }
  }], [{
    key: "save",
    value:
    /**
     * Clone decl for each prefixed values
     */
    function save(prefixes, decl) {
      var _this = this;

      var prop = decl.prop;
      var result = [];

      var _loop = function _loop(prefix) {
        var value = decl._autoprefixerValues[prefix];

        if (value === decl.value) {
          return "continue";
        }

        var item = void 0;
        var propPrefix = vendor.prefix(prop);

        if (propPrefix === '-pie-') {
          return "continue";
        }

        if (propPrefix === prefix) {
          item = decl.value = value;
          result.push(item);
          return "continue";
        }

        var prefixed = prefixes.prefixed(prop, prefix);
        var rule = decl.parent;

        if (!rule.every(function (i) {
          return i.prop !== prefixed;
        })) {
          result.push(item);
          return "continue";
        }

        var trimmed = value.replace(/\s+/, ' ');
        var already = rule.some(function (i) {
          return i.prop === decl.prop && i.value.replace(/\s+/, ' ') === trimmed;
        });

        if (already) {
          result.push(item);
          return "continue";
        }

        var cloned = _this.clone(decl, {
          value: value
        });

        item = decl.parent.insertBefore(decl, cloned);
        result.push(item);
      };

      for (var prefix in decl._autoprefixerValues) {
        var _ret = _loop(prefix);

        if (_ret === "continue") continue;
      }

      return result;
    }
  }]);

  return Value;
}(Prefixer);

module.exports = Value;